module.exports = __webpack_public_path__ + "static/media/jornada.e26ecf63.svg";